import { useQuery } from "@tanstack/react-query";
import apiClient from "@/api/client";

export interface ProjectFilterOption {
  id: string;
  label: string;
}

export interface ProjectFilterOptions {
  client: ProjectFilterOption[];
  branch: ProjectFilterOption[];
  sub_branch: ProjectFilterOption[];
  coordinator: ProjectFilterOption[];
  status: ProjectFilterOption[];
  /** Whether any project is inactive — the feed's first batch never contains one, so the
   *  "Pokaż nieaktywne" checkbox cannot work this out from the loaded rows. */
  has_inactive: boolean;
}

/** Podgląd licznika serii numerowanej („EOP”): ostatni i następny wolny numer. To NIE
 *  rezerwacja — numer nadaje serwer przy tworzeniu przedsięwzięcia z `{N}` w skrócie/nazwie
 *  (pod blokadą serii), więc dwie równoległe wygrane nie dostaną tego samego numeru. */
export interface NextProjectNumber {
  series: string | null;
  count?: number;
  last_number?: number | null;
  last_project?: { id: string; name: string; short_name: string; is_active: boolean } | null;
  next_number?: number;
  placeholder?: string;
}

export function fetchNextProjectNumber(series: string): Promise<NextProjectNumber> {
  return apiClient
    .get<{ data: NextProjectNumber }>("/projects/next-number/", { params: { series } })
    .then((r) => r.data.data);
}

export const projectsApi = {
  filterOptions: () =>
    apiClient
      .get<{ data: ProjectFilterOptions }>("/projects/filter-options/")
      .then((r) => r.data.data),
  nextNumber: fetchNextProjectNumber,
};

export function useProjectFilterOptions() {
  return useQuery({
    queryKey: ["projects", "filter-options"],
    queryFn: projectsApi.filterOptions,
    staleTime: 5 * 60_000,
  });
}
